import { onDomReady } from "../services/on-dom-ready";
import ModalBlocked from "../components/modal/modal-blocked";

let authPopupPromise = new Promise((resolve, reject) => {
  onDomReady.then(() => {
      let element = document.getElementById("auth-popup");
      if (element) {
        let popup = ModalBlocked.get(element);
        resolve(popup);
      } else {
        reject("There is no #auth-popup element on page");
      }
    });
});

const showAuthPopup = () => {
  return authPopupPromise.then(popup => popup.open());
}

const checkAuth = (showPopup = true) => {
  if (window.authorized) {
      return true;
  } else {
      if (showPopup)
          showAuthPopup();
      return false;
  }
};

export { checkAuth, showAuthPopup };